<template>
  <tr>
    <td v-text="firstName" />
    <td v-text="lastName" />
    <td v-text="email" />
    <td v-text="status" />
    <td v-text="statusAt" />
    <td v-text="isRetry ? 'Yes' : 'No'" />
  </tr>
</template>

<script type="text/babel">
export default {
  name: 'EmailDeliveryRow',
  props: {
    delivery: {
      type: Object,
      required: true,
    },
  },
  computed: {
    firstName() {
      return this.delivery.recipient.attributes.first_name
    },
    lastName() {
      return this.delivery.recipient.attributes.last_name
    },
    email() {
      return this.delivery.recipient.attributes.email
    },
    status() {
      const status = this.delivery.attributes.status

      return status.charAt(0).toUpperCase() + status.slice(1)
    },
    isRetry() {
      return this.delivery.attributes.is_retry
    },
    statusAt() {
      return this.delivery.attributes.status_at ? this.$date.toMomentDateTimeFormat(this.delivery.attributes.status_at) : '-'
    },
  },
}
</script>
